import { defineFcm } from '../shared/factory';

export const FCM_SEARCH_USE_VECTOR_COLLECTION = defineFcm('search_use_vector_collection')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'corgi-front-end',
		supportedGroups: { global: true },
		context: 'Search page',
		description: `Determines whether the search page v2 queries the vector-embedding Typesense collection (petitions_vectors_en) instead of the classic collection.

		This flag allows us to test hybrid text+vector search relevance. English (en) only — the front-end ignores this flag for all other locales.`,
	});
